import React, { Component } from 'react'
import callAPI from '../../../../../helpers/callAPI'

class TrimSelect extends Component {
    state = {
        dataLoaded: false,
        year: this.props.year,
        make: this.props.make,
        model: this.props.model,
        trims: [],
    }

    componentDidMount() {
        const fetchData = async () => {
            // Fetch the years
            const result = callAPI(`vehicleInfo/getTrims/${this.state.make}/${this.state.model}?year=${this.state.year}`, 'GET')
            if (result['success'] === true) {
                this.setState({
                    ...this.state,
                    dataLoaded: true,
                    trims: result.trims,
                })
            } else if (result['success'] === false) {
                console.log('Error fetching vehicle trims.')
            } else {
                console.log('Error fetching vehicle trims.')
            }
        }
        fetchData()
    }

    render() {
        return this.state.dataLoaded ? (
            <select className="form-control" onChange={(e) => this.props.handleChangeTrim(e)}>
                <option></option>
                {this.state.trims.map((trim) => {
                    return <option value={trim}>{trim}</option>
                })}
            </select>
        ) : (
            <select className="form-control">
                <option> - </option>
            </select>
        )
    }
}

export default TrimSelect
